<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('form_label_changeStatusDesc') ||
                '文件相关说明（内容会以邮件方式通知相关人员）'
            "
            prop="changeStatusDesc"
          >
            <el-input
              v-model="formData.changeStatusDesc"
              :placeholder="
                $l('form_placeholder_changeStatusDesc') ||
                  '请输入文件相关说明（内容会以邮件方式通知相关人员）'
              "
              type="textarea"
              maxlength="200"
              :rows="4"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { custDocCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      rules: {
        changeStatusDesc: [
          {
            required: true,
            message:
              this.$l('form_placeholder_changeStatusDesc') ||
              '请输入文件相关说明（内容会以邮件方式通知相关人员）',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return

      const res = await this.$api
        .masterCustomerDocEnableApi({
          ...this.formData,
          custDocCode: this.custDocCode,
          sendEmail: true,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_enable_no') || '启用失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_enable_ok') || '启用成功！',
        type: 'success',
      })

      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.confirm()
        })
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-upload,
  .el-upload-dragger {
    width: 100%;
  }
}
</style>
